import React, {useState} from 'react';
import {ConfirmDialog, ConfirmDialogProps} from '../..';
import Button, {ButtonProps} from './Button';

export interface ConfirmButtonProps extends Omit<ButtonProps, 'onClick'> {
    label: string;
    onSubmit?: (e?) => void;
    ConfirmDialogProps?: Omit<ConfirmDialogProps, 'open' | 'onClose' | 'onSubmit'>;
}

export const ConfirmButton: React.FC<ConfirmButtonProps> = ({
    children,
    label,
    ConfirmDialogProps,
    onSubmit = () => {},
    ...props
}) => {
    const [open, setOpen] = useState(false);
    const openDialog = () => setOpen(true);
    const closeDialog = () => setOpen(false);
    return (
        <>
            <Button {...props} onClick={openDialog}>
                {label}
            </Button>
            <ConfirmDialog
                dialogContentTextProps={{align: 'center'}}
                {...ConfirmDialogProps}
                open={open}
                onClose={closeDialog}
                onSubmit={onSubmit}>
                {children}
            </ConfirmDialog>
        </>
    );
};

export default ConfirmButton;
